//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React from "react";

const AdminModalMsg = ({ error, message }) => (
  <div
    className={`alert text-center request-alert ${
      error === true ? "alert-danger" : "alert-success"
    }`}
    role="alert"
  >
    {message}
  </div>
);

export default observer(AdminModalMsg);
